<template>
  <section style="background-color:#11146D; padding: 2rem 3rem;" > 
    <div class="benefits-container"  >
    <div class="image-column">
      <img src="@/assets/banners/cardbeneficios.jpg" 
        alt="Skincare y Maquillaje Importado"  class="promo-image"/>
    </div>

    <div class="content-column">
      <h2 class="title"> BENEFICIOS DE COMPRAR <br>CON NOSOTRAS</h2>
      
      <div class="benefits-grid">
        <div v-for="(benefit, index) in benefits" :key="index" class="benefit-item">
          <div class="icon-wrapper" :style="{ backgroundColor: benefit.bgColor }">
            <img :src="benefit.icon" :alt="benefit.title" class="custom-icon" />
          </div>
          <div class="text-group">
            <h3 class="benefit-title">{{ benefit.title }}</h3>
            <p class="benefit-description">{{ benefit.description }}</p>
          </div>
        </div>
      </div>
    </div>

    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import i301 from '@/assets/icons/301.png'
import i302 from '@/assets/icons/302.png'
import i303 from '@/assets/icons/303.png'
import i304 from '@/assets/icons/304.png'
import i305 from '@/assets/icons/305.png'
import i306 from '@/assets/icons/306.png'


const benefits = ref([
  {
    title: '100% Original & Nuevo',
    description: 'Compramos únicamente en tiendas oficiales y distribuidores autorizados. No vendemos saldos.',
    bgColor: '#e8dff5',
    icon: i301
    
  },
  {
    title: 'Lanzamientos y Tendencias',
    description: 'Las últimas novedades de Estados Unidos y Corea en un solo lugar.',
    bgColor: '#d8f3dc',
    icon: i302
  },
  {
    title: 'Entregas Seguras',
    description: 'Puntos de entrega presenciales (Córdoba, Orizaba y Veracruz), así como envios nacionales',
    bgColor: '#d0f4de',
    icon: i303
  },
  {
    title: 'Belleza Sin Fronteras ',
    description: 'Accede a tendencias internacionales sin salir de México.',
    bgColor: '#fcf6bd',
    icon: i304
  },
  {
    title: 'Comunidad Evermore',
    description: 'Acceso a promociones y beneficios exclusivos con cada compra.',
    bgColor: '#d0f4de',
    icon: i305
  },
  {
    title: 'Beauty Advising',
    description: 'Te ayudamos a elegir tonos, productos y rutinas según tus necesidades.',
    bgColor: '#ffe5ec',
    icon: i306
  }
])


</script>


<style scoped>
.benefits-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  width: 90%;
  margin: 0 auto;
  padding: 2rem;
  background-color: #8dd7fc;
  border-radius: 20px;
}

.image-column {
  width: 100%;
}

.promo-image {
  width: 100%; height: 350px;
  object-fit: cover; display: block;
  border-radius: 20px;
}

.content-column {
  width: 100%;
}

.title {
  font-size: clamp(2rem, 3vw, 3.6rem);
  text-align: center;
  margin-bottom: 8rem;
  color: #11146D;
  font-family: "Magistral_Bold";
}

.benefits-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.icon-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.benefit-title {
  margin: 0 0 .25rem;
  font-size: 2rem;
  font-weight: 700;
  color: #1c1aa0;
  font-family: "Magistral_Bold";
}

.benefit-description {
  margin: 0;
  line-height: 1.5;
  color: #424242;
  font-size:1.5rem;
}

.custom-icon {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

@media (min-width: 320px) {
  .title {
    margin-bottom: 2rem;
    font-size: 2rem;
  }
  .benefits-container {
  width: 100%;}


}

@media (min-width: 768px) {
  .benefits-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  .promo-image {
    height: 450px;
  }
  .title {
    margin-bottom: 2rem;
    font-size: 3.6rem;
  }
  
}


@media (min-width: 1024px) {
  .benefits-container {
    grid-template-columns: 1fr 1.5fr;
    gap: 4rem;
    width: 80%;
  }
  .promo-image {
    height: 100%;
    min-height: 500px;
  }
  .content-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .title {
    margin-bottom: 8rem;
  }
}


</style>